import { render, staticRenderFns } from "./healthResultTip.vue?vue&type=template&id=e5de782e&scoped=true"
import script from "./healthResultTip.vue?vue&type=script&lang=js"
export * from "./healthResultTip.vue?vue&type=script&lang=js"
import style0 from "./healthResultTip.vue?vue&type=style&index=0&id=e5de782e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5de782e",
  null
  
)

export default component.exports